import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import ListCreator from '../../components/Lists/listCreator'
import { getCall } from '../helpers/componentApiHelpers/getCall'
import '../main.css'

class SonucCiceklerList extends Component {

    constructor(props){
        super(props)
        this.state = {
            data: "",
            dataCame: false
        }
    }

    async componentDidMount() {
        try{
            const getData = await getCall("/resultCicek/getall")
            await this.setState({dataCame: true, data: getData.data})
        }
        catch(err){
            console.log(err)
        }
    }

    render() {

        return (
            <React.Fragment>
                <HeaderLine header="Sonuç Çiçek" />
                <button onClick={() => this.props.history.push("/sonucCicekCreate")} className="blue-button add-new-button">Yeni Ekle</button>
                <ListCreator
                    data={this.state.data}
                    dataInfo={[
                        { className: "col-6 col-md-3 col-sm-6 col-lg-2", objectPropName: "name", header: "Çiçek İsmi" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-1", objectPropName: "family", header: "Çiçek Ailesi" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-3", objectPropName: "image", header: "Resim" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-1", objectPropName: "mainType", header: "Ana Kategori" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-1", objectPropName: "shape", header: "Şekil" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-1", objectPropName: "color", header: "Renk" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-1", objectPropName: "size", header: "Boyut" },

                    ]}
                    buttons={{
                        className: "col-2",
                        buttonData: [
                            { name: "Düzenle", func: (d) => {this.props.history.push("/sonucCicekCreate/" + d._id)} },
                            { name: "Resim Galeri", func: (d) => {this.props.history.push("/sonucCicekResimGaleri/" + d._id)} },
                            { name: "Sil" }
                        ]
                    }}
                    dataCame={this.state.dataCame}
                    endPoint="/resultCicek"
                />
            </React.Fragment>
        )
    }
}

export default SonucCiceklerList